import React from 'react';
import styles from './AnonLove.module.css';
import { Link } from 'react-router-dom';
import * as utils from '../../utils/utils';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { tiktokList } from '../../utils/tiktokList';
import tiktokLogo from '../../assets/tiktok.png';
import { MoonLoader } from 'react-spinners';

dayjs.extend(relativeTime);

const formatter = new Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short'
});

export default class AnonLove extends React.Component {

    constructor(props) {
        super(props);

        this.STORAGE_KEY = 'cached_users';

        let username = '';
        try {
            username = this.props.match.params.username.trim() || '';
        } catch(e) {}

        let platform = 0;
        try {
            if ( this.props.location.pathname.includes('/secret-insta') ) {
                platform = 1;
            }
        } catch(e) {}

        let cachedUsers = [];
        try {
            const stored = localStorage.getItem(this.STORAGE_KEY);
            if ( stored ) {
                cachedUsers = JSON.parse(stored);
            }
        } catch (e) {
            console.error("Failed to load users from localStorage", e);
        }

        this.state = {

            cachedUsers,

            platform,

            username, //: 'soppy.com',

            isUserLoading: false,
            isSendLoveLoading: false,

            user: null,
            messages: null,

            message: 'hey i love you, you\'re the best person i\'ve met :)',
            hint: 'your love',
        };
    };

    componentDidMount() {
        const {
            username
        } = this.state;

        if ( username !== '' ) {
            this.getUser();
        }
    };

    componentWillUnmount() {
    };
    
    iOS = () => {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    };

    getMobileOperatingSystem = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }
    
        if (/android/i.test(userAgent)) {
            return "Android";
        }
    
        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }
    
        return "unknown";
    };

    findUser = () => {
        let {
            username,
            platform,
        } = this.state;

        username = username.trim().toLowerCase();

        if ( platform === 0 ) {
            window.location.href = `/secret-tiktok/${username}`;
        }
        else {
            window.location.href = `/secret-insta/${username}`;
        }
    };

    getUser = () => {
        let {
            username,
            cachedUsers,
        } = this.state;

        username = username.trim().toLowerCase();

        this.setState({
            isUserLoading: true,
        }, () => {
            utils.sendRequest('/web/secretLove/findUser', {
                platform: 0,
                username,
            })
            .then(responseData => {
                // console.log('rrr', responseData);

                const {
                    user,
                    messages
                } = responseData;

                const userID = user.userID;

                if ( !cachedUsers.find(user => user.userID === userID ) ) {
                    cachedUsers.unshift(user);
                    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(cachedUsers));
                }

                this.setState({
                    user,
                    messages,
                    cachedUsers,
                });
            })
            .finally(() => {
                this.setState({
                    isUserLoading: false,
                });
            });            
        });
    };

    sendLove = () => {
        let {
            user,
            message,
            hint,
            messages,
            username,
        } = this.state;

        message = message.trim();
        hint = hint.trim();

        messages.unshift({
            message,
            hint,
            created_at: Date.now(),
        });

        this.setState({
            messages,
            isSendLoveLoading: true,
        }, () => {
            utils.sendRequest('/web/secretLove/sendLove', {
                message,
                hint,
                userID: user.userID,
            })
            .then(responseData => {
                // console.log('rrr', responseData);

                // const {
                //     hint,
                //     message
                // } = responseData;
            })
            .catch(e => {
                if ( e === 'Too Many Requests' ) {
                    messages.shift();
            
                    this.setState({
                        messages,
                    });

                    alert(`Please wait 5 minutes before sending another message to ${username}.`);
                }
            })
            .finally(() => {
                this.setState({
                    isSendLoveLoading: false,
                });
            });
        });
    };

    removeCachedItem = (e, index) => {
        e.preventDefault();

        const {
            cachedUsers
        } = this.state;

        cachedUsers.splice(index, 1);
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(cachedUsers));

        this.setState({
            cachedUsers,
        });

        return false;
    };

    renderMainScreen = () => {

        const {
            cachedUsers,
            platform,
            username,
            user,
            messages,
            message,
            hint,
            isUserLoading,
            isSendLoveLoading,
        } = this.state;

        return (
            <div className={styles.rootView}>
                {/* <img src={this.images[currentIndex]} className={this.getFadeContentImageStyle()} /> */}

                {/* <img className={this.getContentImageStyle(2)} src={this.getContentImage(2)} /> */}
                {/* <div className={styles.backgroundOverlay} /> */}

                {
                    platform === 0 &&
                    <div className={styles.tiktokHero}>
                        <img src={tiktokLogo} className={styles.tiktokHeroImage} />
                        <div className={styles.tiktokHeroText}>TikTok Secrets</div>
                        <div className={styles.tiktokHeroSubtext}>
                            <div>Send Anonymous ❤️ to anyone on TikTok</div>
                            <div>TikTok Profile Viewer</div>
                            {/* <br />
                            <div>A kindness wall that transforms messages into positive notes</div> */}
                        </div>
                    </div>
                }

                {
                    platform === 1 &&
                    <div className={styles.instagramHero}>
                    </div>
                }

                {/* <SegmentedControl
                    size='lg'
                    radius='xl'
                    value={platform}
                    onChange={platform => this.setState({ platform })}
                    data={[
                        { label: 'TikTok', value: 0 },
                        { label: 'Instagram', value: 1 },
                    ]}
                /> */}

                <div className={styles.logoView}>
                    {/* <img className={styles.vibeLogo} src={logoImage} /> */}
                </div>

                <div className={styles.contentRootView}>
                    <div className={styles.usernameView}>

                        <input
                            className={styles.usernameTextbox}
                            type="text"
                            placeholder='Enter username'
                            value={username}
                            onChange={e => this.setState({ username: e.target.value })}
                            onKeyDown={e => { if ( e.key === 'Enter' ) { this.findUser() }}}
                        />
                        <button
                            className={styles.button}
                            onClick={this.findUser}
                        >View</button>
                    </div>

                    {
                        isUserLoading &&
                        <div className={styles.loaderView}>
                            <MoonLoader
                                color='#ff0050'
                                size={40}
                            />
                        </div>
                    }

                    {
                        cachedUsers.length > 0 &&
                        <div className={styles.cachedUserListView}>
                            {
                                cachedUsers.map((user, i) => {
                                    return (
                                        <a key={`cachedUser_${i}`} href={`/secret-tiktok/${user.username}`}>
                                            <div className={styles.cachedUserItemView}>
                                                <img
                                                    className={styles.cachedItemImage}
                                                    src={user.avatar}
                                                />
                                                <div className={styles.cachedItemUsernameText}>{user.username}</div>
                                                {/* <div>{defaultItem.name}</div> */}
                                                <div
                                                    onClick={(e) => this.removeCachedItem(e, i)}
                                                    className={styles.cachedItemRemoveView}
                                                >x</div>
                                            </div>
                                        </a>
                                    );
                                })
                            }
                        </div>
                    }

                    {
                        username === '' &&
                        <>
                            <div className={styles.defaultItemsTitleText}>Popular Tiktokers</div>
                            <div className={styles.defaultItemsView}>
                                {tiktokList.map((defaultItem, i) => {
                                    return (
                                        <a key={`defaultItem_${i}`} href={`/secret-tiktok/${defaultItem.username}`}>
                                            <div className={styles.defaultItemView}>
                                                <img
                                                    className={styles.defaultItemImage}
                                                    src={defaultItem.avatar}
                                                />
                                                <div className={styles.defaultItemUsernameText}>{defaultItem.username}</div>
                                                {/* <div>{defaultItem.name}</div> */}
                                            </div>
                                        </a>
                                    );
                                })}
                            </div>
                        </>
                    }

                    {
                        user != null &&
                        <div className={styles.userView}>
                            <div className={styles.userInfoView}>
                                <div>
                                    <img
                                        className={styles.userImage}
                                        src={user.avatar}
                                    />
                                </div>
                                <div>
                                    <div className={styles.usernameText}>{user.username}</div>
                                    <div className={styles.nameText}>{user.name}</div>
                                    <div className={styles.bioText}>{user.bio}</div>
                                </div>
                            </div>
                            <div>
                                <div className={styles.countsView}>
                                    <div className={styles.countView}>
                                        <div className={styles.countText}>{formatter.format(user.numAnonMessages)}</div>
                                        <div className={styles.countInfoText}>secret loves</div>
                                    </div>
                                    <div className={styles.countView}>
                                        <div className={styles.countText}>{formatter.format(user.numPosts)}</div>
                                        <div className={styles.countInfoText}>posts</div>
                                    </div>
                                    <div className={styles.countView}>
                                        <div className={styles.countText}>{formatter.format(user.following)}</div>
                                        <div className={styles.countInfoText}>following</div>
                                    </div>
                                    <div className={styles.countView}>
                                        <div className={styles.countText}>{formatter.format(user.followers)}</div>
                                        <div className={styles.countInfoText}>followers</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {
                        user != null &&
                        <div className={styles.sendLoveView}>
                            <div className={styles.sendLoveTitleText}>Send ❤️ anonymously</div>
                            {
                                !isSendLoveLoading &&
                                <>
                                    <div className={styles.sendLoveItemView}>
                                        <div className={styles.sendLoveItemText}>Message</div>
                                        <input
                                            className={styles.usernameTextbox}
                                            type="text"
                                            placeholder='Enter message'
                                            value={message}
                                            onChange={e => this.setState({ message: e.target.value })}
                                        />
                                    </div>
                                    <div className={styles.sendLoveItemView}>
                                        <div className={styles.sendLoveItemText}>Hint</div>
                                        <input
                                            className={styles.usernameTextbox}
                                            type="text"
                                            placeholder='Enter hint'
                                            value={hint}
                                            onChange={e => this.setState({ hint: e.target.value })}
                                        />
                                    </div>
                                    <div className={styles.sendLoveItemView}>
                                        <div className={styles.sendLoveItemText}></div>
                                        <div className={styles.sendLoveItemInfoText}>
                                            The message will be re-written by AI to keep it kind and respectful.
                                        </div>
                                    </div>
                                    <button
                                        className={styles.button}
                                        onClick={this.sendLove}
                                    >Send</button>
                                </>
                            }
                            {
                                isSendLoveLoading &&
                                <div className={styles.loaderView}>
                                    <MoonLoader
                                        color='#ff0050'
                                        size={40}
                                    />
                                </div>
                            }
                        </div>
                    }

                    {
                        messages != null &&
                        <div className={styles.messagesView}>
                            <div className={styles.messageTitleText}>❤️ messages</div>
                            {
                                messages.map((message, i) => {
                                    return (
                                        <div key={`message_${i}`} className={styles.messageView}>
                                            <div className={styles.messageText}>{message.message}</div>
                                            <div className={styles.messageHint}>- {message.hint}</div>
                                            <div className={styles.messageDate}>{dayjs(message.created_at).fromNow()}</div>
                                        </div>
                                    );
                                })
                            }
                            {
                                messages.length === 0 &&
                                <div className={styles.messageTitleText}>No ❤️ messages yet, so you should leave them one</div>
                            }
                        </div>
                    }

                    <div>

                        <div className={styles.buttonsContainer}>
                            
                            <div className={styles.socialLogosView}>
                                {/* <a href='https://x.com/hqvibeapp' target='_blank'>
                                    <img className={styles.storeLogo} src={xLogo} />
                                </a>
                                <a href='https://www.tiktok.com/@hqvibe' target='_blank'>
                                    <img className={styles.storeLogo} src={tiktokLogo} />
                                </a> */}
                            </div>
                        </div>

                        {/* <button
                            className={`${styles.button} ${styles.buttonF}`}
                            onClick={() => this.setState({ currentScreen: this.screens.Gender })}
                        >
                            Vibe Me Up!
                        </button> */}
                    </div>
                </div>

                {this.renderFooter()}
            </div>
        );
    };

    renderFooter = () => {
        return (
            <div className={styles.footer}>
                <div className={styles.footerContainer}>
                    <div className={styles.footerLinks}>
                        <a href='mailto:vibegameapp@gmail.com' className={styles.link}>Help</a>
                        <Link to="/terms" className={styles.link}>Terms</Link>
                        <Link to="/privacy" className={styles.link}>Privacy</Link>
                        <span className={styles.link}>Not affiliated with TikTok</span>
                    </div>
                    <div className={styles.copyright}>© KVK LLC. 2025</div>
                </div>
            </div>
        );
    };

    render() {
        return this.renderMainScreen();
    };
};